import { warningLogRequest } from "./../logger.js";
import CookieAuth from "./cookieAuth.mjs";

class JWT {
  static urlBase64Decode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch (output.length % 4) {
      case 0:
        break;

      case 2:
        output += "==";
        break;

      case 3:
        output += "=";
        break;

      default:
        throw "Illegal base64url string!";
    }
    return decodeURIComponent(window.atob(output)); // Polyfill https://github.com/davidchambers/Base64.js
  }

  static decodeToken(token) {
    try {
      const parts = token.split(".");
      if (parts.length !== 3) {
        throw new Error("JWT must have 3 parts");
      }
      const decoded = JWT.urlBase64Decode(parts[1]);
      if (!decoded) {
        throw new Error("Cannot decode the token");
      }
      const json = JSON.parse(decoded);
      return json;
    } catch (e) {
      warningLogRequest({ message: "`JWT.decodeToken` Error: " + e });
      localStorage.removeItem("auth");
      CookieAuth.removeAuthCookie();
      // if there is an error, return an object with an exp of 0
      return { exp: 0 };
    }
  }

  static getExpirationDate(token) {
    const decoded = JWT.decodeToken(token);
    if (typeof decoded.exp === "undefined") {
      return null;
    }
    const date = new Date(0); // The 0 here is the key, which sets the date to the epoch
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  static isExpired(token, _offsetSeconds) {
    try {
      const date = JWT.getExpirationDate(token);
      const offsetSeconds = _offsetSeconds || 0;
      if (date === null) {
        return false;
      }
      // Token expired?
      return !(date.valueOf() > new Date().valueOf() + offsetSeconds * 1000);
    } catch (e) {
      warningLogRequest({ message: "`JWT.isExpired` Error: " + e });
      localStorage.removeItem("auth");
      CookieAuth.removeAuthCookie();
      // If theres an error, we want to treat the token as expired
      return true;
    }
  }
}

export { JWT as default };
